





















































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { padHeadPanel3,counter,logoutPanel } from "@/components";
import { TbSettingsPad,TbOrderPad } from '@/http';
import calculate from '@/common/util/calculate';
import { Toast } from 'vant';
import { fmoney } from '@/common/money';
import {PrintEvent4} from "@/common/util/prints";
@Component({
    components: {
        padHeadPanel3,counter,logoutPanel
    },
})
export default class onlineOrderDetail extends Vue {
    public $refs: {
    };


    /**提示弹窗 */
    tipShow = false;
    tipTitle ="";
    tipText="";
    confirmText="";
    cancelText="";
    btnNums=1;
    tipType=1;

    form:any={
        items:[]
    };
    id="";

    list=[];

    fmoney = fmoney;

    /**选中的退回商品 */
    selectedList = [];

    /**是否允许负库存 */
    isZeroStock=null;

    isloading = false;

    isPrintLoading = false;

    /**支付方式 */
    get payName(){
        let str = "";
        if(this.form.paymentMethod){
            switch (this.form.paymentMethod) {
                case 1:
                    str="会员卡"
                    break;
                case 2:
                    str="现金"
                    break;
                case 3:
                    str="微信"
                    break;
                case 4:
                    str="支付宝"
                    break;
                case 5:
                    str="现金+会员卡+微信"
                    break;
                case 6:
                    str="现金+会员卡+支付宝"
                    break;
                case 7:
                    str="现金+微信"
                    break;
                case 8:
                    str="现金+支付宝"
                    break;
                case 9:
                    str="会员卡+微信"
                    break;
                case 10:
                    str="会员卡+支付宝"
                    break;
                case 11:
                    str="现金+会员卡"
                    break;
                    case 13:
                    str="线下微信"
                    break;
                case 14:
                    str="线下支付宝"
                    break;
                case 15:
                    str="现金+线下支付宝"
                    break;
                case 16:
                    str="会员卡+线下支付宝"
                    break;
                case 17:
                    str="现金+线下微信"
                    break;
                case 18:
                    str="会员卡+线下微信"
                    break;
                case 19:
                    str="线下微信+线下支付宝"
                    break;
                case 20:
                    str="现金+会员卡+线下支付宝"
                    break;
                case 21:
                    str="现金+会员卡+线下微信"
                    break;
                case 22:
                    str="现金+线下支付宝+线下微信"
                    break;
                case 23:
                    str="会员卡+线下支付宝+线下微信"
                    break;
            
                default:
                    break;
            }
        }
        return str;
    }

    get deliveryType(){
        let str = "";
        switch (this.form.deliveryType) {
            case 1:
                str="快递"
                break;
            case 2:
                str="自提"
                break;
        
            default:
                break;
        }
        return str;
    }
    get deliveryState(){
        let str = "";
        switch (this.form.deliveryState) {
            case 1:
                str="未提货"
                break;
            case 2:
                str="部分提货"
                break;
            case 3:
                str="已提货"
                break;
        
            default:
                break;
        }
        return str;
    }
    get orderStatus(){
        let str = "";
        switch (this.form.orderStatus) {
            case 1:
                str="待支付"
                break;
            case 2:
                str="支付成功"
                break;
            case 3:
                str="支付失败"
                break;
            case 4:
                str="已关闭"
                break;
        
            default:
                break;
        }
        return str;
    }

    async init(){
        let res = await TbOrderPad.GetOnlineOrderById({id:this.id});
        res.items.map(v=>{
            /**未提货数 */
            let unThNum=calculate.subtraction(v.num,v.selfPickupNum);
            v.thNum=this.isZeroStock?unThNum:Math.min(unThNum,v.posStock);
            v.maxNum=this.isZeroStock?unThNum:Math.min(unThNum,v.posStock);
            v.checked = unThNum>0&&v.isExist?true:false;
        })
        this.form = res;
    }
    /**退回数量 */
    get returnNumAll(){
        let val = 0;
        let arr = this.form.items.filter(v=>v.checked&&Number(v.newReturnNum)>0).map(v=>v.newReturnNum);
        if(arr.length>0){
            val = arr.reduce((a,b)=>calculate.addition(Number(a),Number(b)))
        }
        return val;
    }
    /**退回金额 */
    returnPriceAll =0;

    calcReturnInfo:any = {
        items:[],
    };


    isAutoPrint = true;
    
    created() {
        this.id = this.$route.query.id;
    }
    async mounted() {
        await this.getSetting();
       await this.init();
    }
    

    /**提示弹窗 */
    async tipConfirm(){
        switch (this.tipType) {
          case 1:
            await this.confirmThFun();
            default:
                break;
        }
        this.tipShow = false;
    }
    tipCancel(){
        this.tipShow = false;
    }
    /**计算折扣 */
    getDiscount(item){
        let str = "";
        let val = null;
        let finalPrice = item.finalPrice?item.finalPrice:0;
        let sellingPrice = item.sellingPrice?item.sellingPrice:0;
        val = finalPrice? calculate.multiplication(calculate.division(finalPrice,sellingPrice,2,true),100):0;
        str = val+"%"
        return str;
    }
    /**计算原价 */
    getSellingPrice(item){
        let str = "";
        let val = null;
        val = calculate.multiplication(item.sellingPrice,item.num);
        str = fmoney(val,2,true);
        return str;
    }
    /**计算实际售价 */
    getFinalPrice(item){
        let str = "";
        let val = null;
        val = calculate.multiplication(item.finalPrice,item.num);
        str = fmoney(val,2,true);
        return str;
    }
    /**计数器 */
    finishStep(val,index){
        this.$set(this.form.items[index],'thNum',Number(val));
        let item = this.form.items[index];
        this.$nextTick(()=>{
            if(Number(this.form.items[index].thNum)>Number(item.maxNum)){
                this.$set(this.form.items[index],'thNum',Number(item.maxNum));
            }
            // this.getReturnOrderInfo();
        })
    }
    /**计数器加-验证 */
    chargeAdd(item){
        let val = false;
        if(Number(item.maxNum)<=0||Number(item.maxNum)==Number(item.thNum)){
            val = true;
        }
        return val;
    }
   
   
    async checkChange(item,index){
        if(item.unThNum<=0) return;
        // if(item.checked&&!item.thNum){
        //     this.$set(this.form.items[index],'thNum',item.unThNum);
        // }else{
        // }
    }
   
    confirmFun(){
        let arr = this.form.items.filter(v=>v.checked&&Number(v.thNum)>0);
        if(arr.length==0){
            Toast("请选择提货商品");
            return;
        }
        let num = arr.map(v=>v.thNum).reduce((a,b)=>calculate.addition(a,b));
        this.tipTitle ="提货提醒";
        this.tipText=`提货商品总数${num},确定提货吗？`;
        this.confirmText="确定提货";
        this.cancelText="取消";
        this.btnNums=2;
        this.tipType=1;
        this.tipShow = true;
    }
    goback(){
        this.$router.go(-1);
    }
    changeAutoPrint(val){
        this.isAutoPrint = val;
    }
    /**计算未提货数 */
    getUnThNum(item){
        let val = 0;
        val = calculate.subtraction(item.num,item.selfPickupNum);
        return val;
    }
    /**获取系统配置 */
   async getSetting(){
        let res = await TbSettingsPad.GetTbSettings({settingtype:2});
        this.isZeroStock = res.settingContent.isZeroStock;
    }
    async confirmThFun(){
        if(this.isloading) return;
        this.isloading = true;
        try {
            let shopInfo = JSON.parse(localStorage.getItem('padShopInfo'));
            let userInfo = JSON.parse(localStorage.getItem('padUserinfo'));
            await TbOrderPad.PostOrderPickupGoodsReq({
                id:this.form.id,
                shopNo:shopInfo.shopNo,
                shopId:shopInfo.id,
                cashierName:userInfo.name,
                cashierId:userInfo.id,
                createName:userInfo.name,
                createUserId:userInfo.id,
                memberId:this.form.memberId,
                memberName:this.form.memberName,
                memberPhone:this.form.memberPhone,
                orderNo:this.form.orderNo,
                itemDtos:this.formateArr()
            })
            Toast("提货成功");
            this.isloading = false;
            await this.init();
            if(this.isAutoPrint){
                this.printTest();
            }
        } catch (error) {
             this.isloading = false;
        }
    }
   formateArr(){
    let arr =[];
    let checkArr = this.form.items.filter(v=>v.checked&&Number(v.thNum)>0);
    arr = checkArr.map(v=>{
        return{
            id:v.id,
            selfPickupNum:v.thNum,
            goodsItemId:v.posGoodsItemId,
            goodsId:v.posGoodsId,
            price:v.discountedPrice,
            goodsName:v.name,
            goodsSpecsName:v.goodsSpecsName,
            barCode:v.barCode,
            articleNo:v.articleNo,
        }
    })
    return arr;
   }
   async printTest(){
        if(this.isPrintLoading) return;
        let address = localStorage.getItem('padShopInfo')?JSON.parse(localStorage.getItem('padShopInfo')).address:''
        this.isPrintLoading = true;
      
        let form = Object.assign({},{orderInfo:Object.assign({},this.form,{address:address})},{type:'onlineReceipt'})
        console.log('form',form);
        let time = 3000;
        PrintEvent4(form)
        setTimeout(()=>{
        this.isPrintLoading = false;
        },time)
        

    }
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/cashier/onlineOrderDetail.vue